<myre-button
  icon="myre-icon-language"
  [label]="_selectedLang | localeRegion"
  [theme]="ButtonTheme.Secondary"
  [subTheme]="ButtonSubTheme.Blue"
  [height]="ButtonHeight.Small"
  [ariaLabel]="_wordings._ui.system.manageLanguage()"
  (onClick)="_openLanguageModal()"
/>

<myre-actions-dropdown
  icon="myre-icon-info"
  [buttonTheme]="ButtonTheme.Secondary"
  [buttonSubTheme]="ButtonSubTheme.Blue"
  [buttonHeight]="ButtonHeight.Small"
  [dropdownItems]="_dropdownItems"
/>

<img
  class="logo"
  [ngSrc]="{ type: 'logo', name: _logoName() } | assetsPipe"
  [tooltip]="logoTooltip"
  (mouseenter)="_logoName.set(LogoDeclination.Color)"
  (mouseleave)="_logoName.set(LogoDeclination.Grey)"
  width="24"
  height="24"
/>

<ng-template #logoTooltip>
  <div class="tooltip">
    <div class="tooltip__title">MYRE</div>
    <div class="tooltip__text">Make your data work for you</div>
    <div class="tooltip__footer">V{{ _versionApp }}</div>
  </div>
</ng-template>
